// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./messageTooltip.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.web.messageTooltip', deps)

  .directive('blMessageTooltip', () => ({
    restrict: 'EA',
    scope: {
      isLightTheme: '=?',
    },
    template: require('./messageTooltip.html'),
    controller: require('./messageTooltipCtrl'),
    controllerAs: 'vm',
    bindToController: true,
    transclude: true,
  }));
